import { IconName } from 'ui/components'

import { ItemColors } from '../types'

import * as SC from './styles'

type Props = {
  title: string
  icon: IconName
  color: ItemColors

  url?: string
  onClick?: () => void
}

export const ItemWithIcon = (props: Props) => {
  const { icon, color, title, url, onClick } = props

  return (
    <>
      {color === 'neutral' && (
        <SC.ItemWithIconNeutral
          to={url}
          onClick={(e) => {
            if (onClick) {
              e.preventDefault()
              onClick()
            }
          }}
          data-qa={`table-action-${title.toString().toUpperCase()}`}
        >
          <SC.WrappedIcon name={icon} />
          <span>{title}</span>
        </SC.ItemWithIconNeutral>
      )}

      {color === 'negative' && (
        <SC.ItemWithIconNegative
          to={url}
          onClick={(e) => {
            if (onClick) {
              e.preventDefault()
              onClick()
            }
          }}
          data-qa={`table-action-${title.toString().toUpperCase()}`}
        >
          <SC.WrappedIcon name={icon} />
          <span>{title}</span>
        </SC.ItemWithIconNegative>
      )}

      {color === 'positive' && (
        <SC.ItemWithIconPositive
          to={url}
          onClick={(e) => {
            if (onClick) {
              e.preventDefault()
              onClick()
            }
          }}
          data-qa={`table-action-${title.toString().toUpperCase()}`}
        >
          <SC.WrappedIcon name={icon} />
          <span>{title}</span>
        </SC.ItemWithIconPositive>
      )}
    </>
  )
}
